import {FormSendWrapper, Response} from '../interfaces';
import {get, post} from "../../../DAL/data-provider";
import {getQueryString} from "../../../domain/url-provider";
export class FormSettings
{
    static readonly FORM_NAME= window.location.pathname.split("/").pop();
    static readonly FORM_NAME_PARAM= getQueryString()['formName'];
};

/**
 * get Data onLoad
 */
export const getForm = async (formType:string) : Promise<Response> => {
    return get('/api/contactusforms/get-form?formName=' + formType);
};

export const setForm = async (formSend: FormSendWrapper, formType:string) : Promise<Response> => {
    //console.log(`setForm:`,formSend);
    formSend.formName = formType;
    return post('/api/contactusforms/set-form', formSend);
};

export const getSectionClass = (sectionName:string) => {
    switch (sectionName) {
        case 'FormSections.OneColumn':
            return 'one-column';
        case 'FormSections.TwoColumns':
            return 'two-columns flex flex-col lg:flex-row lg:column-count-2 lg:gap-4';
        case 'FormSections.ThreeColumns':
            return 'three-columns flex flex-col lg:flex-row lg:column-count-3 lg:gap-4';

        default:
            return 'no-class';
    }
};
